
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import components from 'vux/src/datas/vux_component_list.json'

import { mapState } from 'vuex'
import SyMobile from './components/control/sy-mobile'
import SyInput from './components/control/sy-input'
import SyAddress from './components/control/sy-address'
import SyCheck from './components/control/sy-check'
import SyCover from './components/control/sy-cover'
import SyDate from './components/control/sy-date'
import SyDescriptionText from './components/control/sy-description-text'
import SyFileupload from './components/control/sy-fileupload'
import SyHeader from './components/control/sy-header'
import SyPicker from './components/control/sy-picker'
import SyRange from './components/control/sy-range'
import SyRater from './components/control/sy-rater'
import SySelectText from './components/control/sy-select-text'
import SySign from './components/control/sy-sign'
import SySwitch from './components/control/sy-switch'
import SyText from './components/control/sy-text'





export default {
name: 'demoList',
components: {
Flexbox,
FlexboxItem,
SyMobile,
SyInput,
SyAddress,
SyCheck,
SyCover,
SyDate,
SyDescriptionText,
SyFileupload,
SyHeader,
SyPicker,
SyRange,
SyRater,
SySelectText,
SySign,
SySwitch,
SyText,




},
mounted() {},
methods: {},
data() {
return {
dynamicControlArray: [
{ name: '封面', type: 'SyCover', control: SyCover },
{ name: '手机号', type: 'SyMobile', control: SyMobile },
{ name: '输入框', type: 'SyInput', control: SyInput },
{ name: '省市区', type: 'SyAddress', control: SyAddress },
{ name: '单选/多选', type: 'SyCheck', control: SyCheck },
{ name: '日期', type: 'SyDate', control: SyDate },
{ name: '文本', type: 'SyDescriptionText', control: SyDescriptionText },
{ name: '图片上传', type: 'SyFileupload', control: SyFileupload },
{ name: '头部', type: 'SyHeader', control: SyHeader },
{ name: '选择项', type: 'SyPicker', control: SyPicker },
{ name: '范围选择', type: 'SyRange', control: SyRange },
{ name: '评分', type: 'SyRater', control: SyRater },
{ name: '文本侯选', type: 'SySelectText', control: SySelectText },
{ name: '签名', type: 'SySign', control: SySign },
{ name: '开关', type: 'SySwitch', control: SySwitch },
{ name: '文本描述', type: 'SyText', control: SyText }
],
formControlMenu: [

{
name: '封面',
icon: require('@/assets/form/fenmian.png')
},
{
name: '描述文本',
icon: require('@/assets/form/text.png')
},
{
name: '输入框',
icon: require('@/assets/form/input.png')
},
{
name: '单选框/复选框',
icon: require('@/assets/form/checkbox.png')
},
{
name: 'picker选择框',
icon: require('@/assets/form/picker.png')
},
{
name: '范围选择',
icon: require('@/assets/form/range.png')
},
{
name: '评分插件',
icon: require('@/assets/form/rate.png')
},
{
name: '省市区',
icon: require('@/assets/form/pca.png')
},
{
name: '手机号',
icon: require('@/assets/form/mobile.png')
},
{
name: '数字',
icon: require('@/assets/form/number.png')
},
{
name: '开关',
icon: require('@/assets/form/switch.png')
},
{
name: '签名',
icon: require('@/assets/form/sign.png')
},
{
name: '文本侯选框',
icon: require('@/assets/form/more_select.png')
}
]
}
},
computed: {}
}



// WEBPACK FOOTER //
// ./src/components/design/form_add.vue